import { Component, OnInit, Input } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { FormBuilder } from "@angular/forms";
import { MatTableDataSource } from "@angular/material";
import { Sort } from "@angular/material/sort";
import { MDBModalRef, MDBModalService } from "ng-uikit-pro-standard";
import { DataService } from "./../../data.service";
import { ToastService } from "ng-uikit-pro-standard";

@Component({
  selector: "app-metafieldlist",
  templateUrl: "./metafieldlist.component.html",
  styleUrls: ["./metafieldlist.component.scss"],
})
export class MetafieldListComponent implements OnInit {
  @Input() metaobjectid: string;
  @Input() objectname: string;
  @Input() parentobjectid: string;
  @Input() parentobjectname: string;
  @Input() embeddedobject: boolean;
  @Input() virtualobject: boolean;

  modalRef: MDBModalRef;

  matSort: any;
  isLoading = false;
  isError = false;
  errorMessage = "";
  metaobjectId = "";
  objectName = "";
  metafieldList = [];
  metaobjectLists = [];
  parentobjectId = "";
  parentobjectName = "";
  embeddedObject = false;
  virtualObject = false;
  metafieldhistory: boolean;

  displayedColumns: string[] = [
    "id",
    "labelname",
    "fieldname",
    "fieldtype",
    "required",
    "primaryfield",
    "parentobjectname",
    "modifiedby",
    "modifieddate",
    "active",
  ];
  dataSource = new MatTableDataSource();

  sorting = {
    fieldName: "labelname",
    order: "ASC",
  };

  sortData(sort: Sort) {
    console.log("sort", sort);
    if (!sort.active || sort.direction === "") {
      //default sorting
      this.sorting.fieldName = "createddate";
      this.sorting.order = "ASC";
    } else {
      const isAsc = sort.direction.toLocaleUpperCase() === "ASC";
      this.sorting.fieldName = sort.active;
      if (isAsc) {
        this.sorting.order = "ASC";
      } else {
        this.sorting.order = "DESC";
      }
    }

    this.getMetafields().then((res) => {
      console.log("response11111", res);
    });
  }

  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000,
    };
    this.toastrService.success(data, "", options);
  }
  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Application Error!", options);
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark",
    };
    this.toastrService.warning(data, "", options);
  }

  delete(id: number) {
    // alert(id)
    const organizationid = localStorage.getItem("crm_orgid");
    var userDetail = JSON.parse(localStorage.getItem("crm_userdetails"));

    const domain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.domain`
    );
    const subdomain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.subdomain`
    );
    const confirmDelete = window.confirm("Are you sure you want to delete?");

    if (!confirmDelete) {
      return;
    }

    this.isLoading = true;
    this.dataService
      .deleteMetafield(
        organizationid,
        domain,
        subdomain,
        this.metaobjectid,
        id,
        userDetail.profilename
      )
      .subscribe(
        (res) => {
          // alert('****res****' + JSON.stringify(res));
          console.log(res);
          if (res.success == 1) {
            // alert("Are you sure?")
            window.location.reload();

            this.isLoading = false;
            this.showSuccess(res.message);
          } else {
            console.log("error while deleting");
            this.isLoading = false;
            this.showError(res.message);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          console.log(err.error.message.detail);

          this.showError(err.error.message.detail);
        }
      );
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private dataService: DataService,
    private modalService: MDBModalService,
    private toastrService: ToastService
  ) {}

  ngOnInit() {
    this.metaobjectId = this.metaobjectid;
    this.objectName = this.objectname;
    this.parentobjectId = this.parentobjectid;
    this.parentobjectName = this.parentobjectname;
    this.embeddedObject = this.embeddedobject;
    this.virtualObject = this.virtualobject;

    console.log("this.embeddedobject", this.embeddedobject);
    console.log("this.virtualobject", this.virtualobject);

    this.getMetaobjectById();
    this.getMetafieldHistory();
    //load fields
    this.getMetafields().then((res) => {
      console.log("response11111", res);
    });
  }

  newField() {
    /*var qparams = {
      metaobjectid: this.metaobjectId,
      metaobjectname: this.objectName,
      parentobjectid: this.metaobject.parentobjectid,
      embeddedobject: this.metaobject.embeddedobject,
      virtualobject: this.metaobject.virtualobject,
    };
    //console.log("qparams",qparams);
    //this.router.navigate(['/home/metafield/new'], { queryParams: qparams });
    */
    //console.log("path", '/home/metafield/new/'+ this.metaobjectId + '/' + this.objectName + '/' + (this.metaobject.parentobjectid==''?'none': this.metaobject.parentobjectid) + '/' + this.metaobject.embeddedobject + '/' + this.metaobject.virtualobject);

    this.router.navigateByUrl(
      "/home/metafield/new/" +
        this.metaobjectId +
        "/" +
        this.objectName +
        "/" +
        (this.parentobjectId == "" ? "none" : this.parentobjectId) +
        "/" +
        (this.parentobjectName == "" ? "none" : this.parentobjectName) +
        "/" +
        this.embeddedObject +
        "/" +
        this.virtualObject
    );
  }

  fieldHistory() {
    if (this.metafieldhistory == true) {
      this.router.navigateByUrl(
        "/home/metafieldhistory/edit/" +
          this.metaobjectId +
          "/" +
          this.objectName
      );
    } else {
      this.router.navigateByUrl(
        "/home/metafieldhistory/new/" +
          this.metaobjectId +
          "/" +
          this.objectName
      );
    }
  }

  fieldDependencies() {
    this.router.navigateByUrl(
      "/home/fielddependencies/list/" +
        this.metaobjectId +
        "/" +
        this.objectName
    );
  }

  metaobjectList() {
    this.router.navigateByUrl("home/metaobjectlist");
  }

  getMetaobjectById() {
    return new Promise((resolve, reject) => {
      console.log("getMetaobjectById");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          metaobject: {
            id: this.metaobjectId,
          },
        },
      };

      this.isLoading = true;
      this.dataService.getMetaobjectById(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            this.metaobjectLists = res.data.metaobject;
            console.log(this.metaobjectLists);

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No Object data!");
            this.errorMessage =
              res != null ? res.message : "No metaobject data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  getMetafields() {
    return new Promise((resolve, reject) => {
      console.log("getMetafields");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          sortfield: this.sorting.fieldName,
          sortorder: this.sorting.order,
          metafield: {
            metaobjectid: this.metaobjectId,
          },
        },
      };
      console.log("postOption", postOption);
      this.isLoading = true;
      this.dataService.getMetaFields(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            this.metafieldList = res.data.metafields;
            //assign table data will refresh it automatically
            this.dataSource.data = this.metafieldList;

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No metafields data!");
            this.errorMessage =
              res != null ? res.message : "No metafields data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  getMetafieldHistory() {
    return new Promise((resolve, reject) => {
      console.log("getMetafields");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          metafieldhistory: {
            metaobjectid: this.metaobjectId,
          },
        },
      };
      console.log("postOption", postOption);
      this.isLoading = true;
      this.dataService.getMetaFieldHistory(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            // this.metafieldHistoryList = res.data.metafields;
            //assign table data will refresh it automatically
            if (res.data.metafieldhistory.length > 1) {
              this.metafieldhistory = true;
            }
            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No metafieldhistory data!");
            this.errorMessage =
              res != null ? res.message : "No metafieldhistory data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }
}
